import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { setPassword as setPasswordAction } from '../../actions/auth';

import {
    trackSetPasswordClicked as trackSetPasswordClickedAction,
    trackResetPasswordEmailReturn as resetPasswordEmailClickedAction,
} from '../../actions/gaTracking';

import {
    cancelToS as cancelToSAction,
    acceptToS as acceptToSAction,
    showToS as showToSAction,
} from '../../actions/tos';

import SetPasswordPage from './SetPasswordPage';

const _mapStateToProps = ({ authentication, form, social }) => ({
    form,
    locale: authentication.locale,
    recaptcha2PublicKey: authentication.recaptcha2PublicKey,
    recaptcha3PublicKey: authentication.recaptcha3PublicKey,
    showCaptcha: authentication.displayCaptcha,
    fp: authentication.fp,
    socialSSOSettings: social.socialSSOSettings,
    authNotificationOptions: authentication.authNotificationOptions,
    disableRecaptcha3: authentication.disableRecaptcha3,
});

const _mapDispatchToProps = {
    handleSetPassword: setPasswordAction,
    cancelToS: cancelToSAction,
    acceptToS: acceptToSAction,
    showToS: showToSAction,
    handleResetPasswordEmailClicked: resetPasswordEmailClickedAction,
    handleTrackSetPasswordClicked: trackSetPasswordClickedAction,
};

export default withRouter(
    connect(_mapStateToProps, _mapDispatchToProps)(SetPasswordPage),
);
